import axios from 'axios'
import { Message,Modal } from 'iview'
import router from "../router/index"
import {baseUrl} from "./../config"

axios.defaults.baseURL =baseUrl;

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.token = localStorage.getItem('his_token');
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

//添加响应拦截器
axios.interceptors.response.use(function(response){  
  //对响应数据做些事
  if(response.data.code === 0){
    return response;
  }else if(response.data.code === 401){
    //Message.warning(response.data.msg);
    Modal.confirm({
      title: '医诺云检HIS平台',
      content: 'token已过期，请重新登录',
      okText: '去登录',
      cancelText: '等会再说',
      onOk: () => {
        router.push("/")
      },
      onCancel: () => {
      }
    });

  }else if(response.data.code === 500){
    Message.error('系统维护中，请稍后再试！');
  }else if(response.data.code === 2){
    let msg = response.data.data[0].msg;
    console.log(msg);

    Message.warning(msg);
  }else{
    Message.warning(response.data.msg);
  }
},function(error){
  //请求错误时做些事
  //  Message.error(error);
  //  Message.warning('系统维护中，请稍后再试！');
});

export default  axios;



// WEBPACK FOOTER //
// ./src/api/axios.js